import React from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneAlt } from "@fortawesome/free-solid-svg-icons";

import coverSrc from "../../assets/img/generic/4.jpg";
import Flex from "../common/Flex";
import ProfileBanner from "./ProfileBanner";
import VerifiedBadge from "../common/VerifiedBadge";

interface PropsType {
	fullName: string;
	userName: string;
	userType: string;
	email: string;
	phone: {
		phNumber: string;
		phoneCode: string;
	};
	warnings?: number;
	collabers?: number;
	clipsShared?: number;
	profileImage?: string;
}

const Banner: React.FC<PropsType> = ({
	fullName,
	userName,
	userType,
	email,
	phone,
	warnings,
	collabers,
	clipsShared,
	profileImage,
}) => {
	return (
		<ProfileBanner>
			<ProfileBanner.Header avatar={profileImage || ""} coverSrc={coverSrc} />
			<ProfileBanner.Body>
				<Row>
					<Col lg={8}>
						<h4 className="mb-1">
							{fullName} <VerifiedBadge />
						</h4>
						<p className="fw-normal" style={{ color: "#e83c4a" }}>
							@{userName}
						</p>
						<p className="fs-0 fw-normal">
							{(userType === "b-user" && "Business") ||
								(userType === "c-user" && "Charity") ||
								(userType === "g-user" && "General") ||
								(userType === "admin-user" && "Admin") ||
								(userType === "super-admin" && "Super Admin")}{" "}
							User
						</p>
						<h5
							className={`fs-0 fw-normal  ${email ? "cursor-pointer" : ""}`}
							onClick={() => email && window.open(`mailto:${email}`)}>
							<FontAwesomeIcon
								icon={faEnvelope}
								className="text-500 fw-normal"
							/>{" "}
							{email ?? ""}
						</h5>
						<h5 className="fs-0 fw-normal">
							<FontAwesomeIcon
								icon={faPhoneAlt}
								className="text-500 fw-normal"
							/>{" "}
							{(phone?.phoneCode ?? "") + " " + (phone?.phNumber ?? "")}
						</h5>

						<div className="border-dashed-bottom my-4 d-lg-none" />
					</Col>
					<Col className="ps-2 ps-lg-3">
						{clipsShared && <Flex alignItems="center" className="mb-2">
							<div className="flex-1">
								<span className="text-500 fw-normal">Clips Shared </span>
								<h5 className="mb-0"> {clipsShared ?? 0}</h5>
							</div>
						</Flex>
						}

						{collabers && <Flex alignItems="center" className="mb-2">
							<div className="flex-1">
								<span className="text-500 fw-normal">Collabers </span>
								<h5 className="mb-0"> {collabers ?? 0}</h5>
							</div>
						</Flex>
						}

						{warnings && <Flex alignItems="center" className="mb-2">
							<div className="flex-1">
								<span className="text-500 fw-normal">Warnings </span>
								<h5 className="mb-0"> {warnings ?? 0}</h5>
							</div>
						</Flex>}
					</Col>
				</Row>
			</ProfileBanner.Body>
		</ProfileBanner>
	);
};

export default Banner;
